import { Outlet } from "react-router-dom";
import Sidebar from "./components/SideBar";
import { FC, useEffect } from "react";
import MessageBar from "./components/MessageBar";
import clsx from "clsx";
import { setHideHeader, setLayoutType } from "../../app/chatAgent/chatAgentSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

interface IProps {
    layoutType: "PAGE" | "LEFT_PANEL" | "FLOATING_PANEL";
    hideHeader?: boolean;
    className?: string;
}

const ChatAgent: FC<IProps> = ({ layoutType, hideHeader = false, className }) => {
    const dispatch = useAppDispatch();
    const { activeRoom } = useAppSelector((state) => state.chatagent);

    useEffect(() => {
        dispatch(setLayoutType(layoutType))
    }, [layoutType]);

    useEffect(() => {
        dispatch(setHideHeader(hideHeader))
    }, [hideHeader]);

    const isSelectedChatRoom = () => {
        return (activeRoom.roomId && layoutType == "LEFT_PANEL" || layoutType == "FLOATING_PANEL");
    }
    return (
        <div className={clsx("flex", className)}>
            <Sidebar className={clsx(isSelectedChatRoom() ? "hidden" : "")} />
            {layoutType == "PAGE" ? <Outlet /> : <MessageBar className={!isSelectedChatRoom() ? "hidden" : ""} />}
        </div>
    );
};

export default ChatAgent;
